import React, { useEffect } from 'react';
import { DashboardLayout } from '../../components/florist-dashboard/DashboardLayout';
import EnhancedNotificationSettings from '../../components/dashboard/EnhancedNotificationSettings';
import { useAuth } from '@/hooks/useAuth';
import { useNavigate } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { TypographyH1, TypographyP } from '@/components/ui/typography';

const NotificationsPage: React.FC = () => {
  const { user, loading: authLoading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (authLoading) return;
    if (!user) {
      navigate("/login");
      return;
    }
    // Check if user has florist role, even if store profile verification is pending
    const userRole = user?.user_metadata?.role;
    if (userRole !== "florist" && userRole !== "admin") {
      navigate("/");
    }
  }, [user, authLoading, navigate]);

  if (authLoading) {
    return (
      <DashboardLayout>
        <div className="flex justify-center items-center h-[60vh]">
          <Loader2 className="h-8 w-8 animate-spin text-brand-primary" />
        </div>
      </DashboardLayout>
    );
  }

  return (
    <DashboardLayout>
      <div className="p-6 space-y-6">
        <div className="flex flex-col space-y-2 mb-6">
          <TypographyH1 className="text-3xl font-bold">Notifications</TypographyH1>
          <TypographyP className="text-muted-foreground">
            Manage your notification preferences and recipients.
          </TypographyP>
        </div>
        
        <EnhancedNotificationSettings />
      </div>
    </DashboardLayout>
  );
};

export default NotificationsPage; 